import styled from 'styled-components'

export const TaskTitleUpdateActionLoadingWrapper = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: center;
   margin: 60px 30px 32px 48px;
   span:nth-child(1) {
      flex-grow: 1;
   }
`

export const TaskIdAndActionsLoadingWrapper = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: center;
   padding-bottom: 24px;
   border-bottom: 1px solid rgb(228, 231, 235);
   margin-left: 48px;
   margin-right: 24px;
`
export const TaskDetailedViewWrapper = styled.div`
   display: flex;
   flex-direction: column;
   width: 924px;
   margin: auto;
   height: 92vh;
`
export const HeaderLoadingWrapper = styled.div`
   display: flex;
   flex-direction: column;
   width: 100%;
`
export const TaskIdAndCopyLoaderWrapper = styled.div`
   display: flex;
   align-items: center;
`
export const TaskDescriptionLoadingWrapper = styled.div`
   margin-left: 48px;
   margin-right: 40px;
   margin-top: 24px;
`
export const TaskFieldsLoadingWrapper = styled.div`
   display: flex;
   flex-wrap: wrap;
   justify-content: space-between;
   margin-left: 48px;
   margin-right: 96px;
   margin-top: 24px;
`
export const FieldLoadingWrapper = styled.div`
   display: flex;
   flex-direction: column;
   margin-bottom: 24px;
`
